<template>
  <div class="Yzcl" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <div class="yzcl_header" style="top: 1rem">
      <div class="title_t">
        <p class="name">更多优质策略</p>
      </div>

      <div class="card">
        <van-tabs type="card" :ellipsis="false" v-model="active" @change="handleChangeTabs">
          <van-tab title="信号活跃"></van-tab>
          <van-tab title="短线高涨幅"></van-tab>
          <van-tab title="中线高涨幅"></van-tab>
          <van-tab title="长线高涨幅"></van-tab>
          <van-tab title="短线高概率"></van-tab>
          <van-tab title="中线高概率"></van-tab>
          <van-tab title="长线高概率"></van-tab>
        </van-tabs>
      </div>

      <p class="hint" v-if="active === 0">按策略近1年信号发生次数从多到少排序</p>
      <p class="hint" v-if="active === 1">
        按策略历史回测的最优平均涨幅从高到低排序，且持股期为短线(≤5天)
      </p>
      <p class="hint" v-if="active === 2">
        按策略历史回测的最优平均涨幅从高到低排序，且持股期为中线(5~20天)
      </p>
      <p class="hint" v-if="active === 3">
        按策略历史回测的最优平均涨幅从高到低排序，且持股期为长线(≥20天)
      </p>
      <p class="hint" v-if="active === 4">
        按策略历史回测的最大上涨概率从高到低排序，且持股期为短线(≤5天)
      </p>
      <p class="hint" v-if="active === 5">
        按策略历史回测的最大上涨概率从高到低排序，且持股期为中线(5~20天)
      </p>
      <p class="hint" v-if="active === 6">
        按策略历史回测的最大上涨概率从高到低排序，且持股期为长线(≥20天)
      </p>

      <div class="list_header">
        <p class="left_name">策略名称</p>

        <ul class="click">
          <li>
            <span class="name">日涨幅</span>
          </li>
          <li>
            <span class="name">今日信号</span>
          </li>
          <li>
            <span class="name" v-if="active == 0">近1年信号</span>
            <span class="name" v-if="active == 1 || active == 2 || active == 3">最优平均涨幅</span>
            <span class="name" v-if="active == 4 || active == 5 || active == 6">最大上涨概率</span>
          </li>
        </ul>
      </div>
    </div>

    <ul class="list" v-if="!isShoWempty">
      <li
        class="list_li"
        v-for="item in clList"
        :key="item.f_id_arr + item.ct"
        @click="goclDetail(item)"
      >
        <div class="list_li_top">
          <p class="name van-ellipsis">{{ item.s_name }}</p>
          <div class="t_right">
            <!-- 日涨幅 -->
            <p :class="[judgeColor(item.RiZhangFu)]">
              {{ toFixedNum(item.RiZhangFu * 100, 2, '%') }}
            </p>

            <!-- 今日信号数 -->
            <p>{{ item.XinHaoShuLiang || '0' }}只</p>

            <!-- 近一年信号数 -->
            <p v-if="active == 0">{{ item.HistoryCount }}次</p>

            <!-- 最优平均涨幅 -->
            <p :class="[judgeColor(item.BestAvgRate)]" v-if="false">
              {{ toFixedNum(item.BestAvgRate * 100, 2, '%') }}
            </p>

            <!-- 最优平均涨幅 --带最优天数 -->
            <div
              v-if="active == 1 || active == 2 || active == 3"
              style="display: flex; justify-content: end; align-items: center"
            >
              <span class="day">{{ item.BestAvgCycle }}天</span>
              <span :class="[judgeColor(item.BestAvgRate)]">
                {{ toFixedNum(item.BestAvgRate * 100, 2, '%') }}
              </span>
            </div>

            <!-- 最大上涨概率 --带最优天数 -->
            <div
              v-if="active == 4 || active == 5 || active == 6"
              style="display: flex; justify-content: end; align-items: center"
            >
              <span class="day">{{ item.MaxRiseCycle }}天</span>
              <span :class="[judgeColor(item.MaxRiseRate)]">
                {{ toFixedNum(item.MaxRiseRate * 100, 2, '%') }}
              </span>
            </div>
          </div>
        </div>

        <p class="desc van-ellipsis">{{ item.s_desc }}</p>

        <div class="list_li_bottom">
          <div class="btm_li" v-if="active == 0 || active == 4 || active == 5 || active == 6">
            <p class="btm_li_left">最优涨幅</p>

            <div class="btm_li_right">
              <p>{{ item.BestAvgCycle }}天</p>
              <p :class="[judgeColor(item.BestAvgRate)]">
                {{ toFixedNum(item.BestAvgRate * 100, 2, '%') }}
              </p>
            </div>
          </div>

          <div class="btm_li" v-if="active == 0 || active == 1 || active == 2 || active == 3">
            <p class="btm_li_left">最大概率</p>

            <div class="btm_li_right">
              <p>{{ item.MaxRiseCycle }}天</p>

              <p :class="[judgeColor(item.MaxRiseRate)]">
                {{ toFixedNum(item.MaxRiseRate * 100, 2, '%') }}
              </p>
            </div>
          </div>
        </div>
      </li>

      <div class="loadingMore">
        <van-button
          :loading="loading"
          type="info"
          loading-text="加载中..."
          @click="loadingMore"
          :disabled="disabled"
          >{{ loading_text }}</van-button
        >
      </div>
    </ul>

    <van-empty description="暂无数据" v-else />
  </div>
</template>

<script>
import { getHotClLeaderboard, getFactorHq } from '@/api/index.js';

import { judgeColor, toFixedNum, noRepeat,compareVersions } from '@/utils/format';
import mixin from '@/mixins/index.js';

export default {
  name: 'Yzcl',
  mixins: [mixin],
  props: [],

  data() {
    return {
      active: 0,
      isVip: false,
      // sortKey: 'dailyChange',
      // reverse: false,
      page: 1,
      clList: [],
      f_id_arr: [],
      loading: true,
      loading_text: '点击加载更多',
      disabled: false,
      isShoWempty: false
    };
  },
  filters: {},
  created() {},
  //计算属性
  computed: {},
  watch: {
    '$store.state.isVip': {
      handler(newValue) {
        this.isVip = newValue;
      },
      immediate: true // 立即执行一次
    }
  },
  async mounted() {
    this.getHotClLeaderboardFun();
  },
  beforeDestroy() {},
  methods: {
    judgeColor,
    toFixedNum,
    compareVersions,

    //点击排序
    // toggleArrow(key) {
    //   this.sortKey = key;
    //   this.reverse = !this.reverse;
    // },

    //点击切换
    handleChangeTabs: function (i) {
      this.page = 1;
      this.clList = [];
      this.getHotClLeaderboardFun();
    },

    // 获取热门策略接口数据
    getHotClLeaderboardFun: function () {
      let _this = this;
      _this.loading = true;
      _this.loading_text = '加载中...';
      _this.f_id_arr = [];
      let obj = {
        type: _this.active + 1, //1-信号活跃<br />2. 短线高涨幅 <br />3.中线高涨幅<br />4.长线高涨幅<br />5. 短线高概率<br />6. 中线高概率<br />7.长线高概率
        start: _this.page,
        count: 10
      };
      getHotClLeaderboard(obj)
        .then((res) => {
          if (res.err == 200) {
            res.data.forEach((i) => {
              _this.f_id_arr.push(i.f_id_arr.replaceAll(',', '_'));
            });

            _this.getHqData(noRepeat(_this.f_id_arr).toString(), res.data);

            if (res.data.length < 10) {
              _this.disabled = true;
              _this.loading_text = '已加载全部';
            } else {
              _this.loading_text = '点击加载更多';
              _this.disabled = false;
            }
          } else {
            _this.loading = false;
            _this.disabled = true;
            _this.loading_text = '已加载全部';
          }
        })
        .catch(() => {
          _this.loading = false;
          _this.loading_text = '加载失败，点击重试';
        });
    },

    // 获取行情数据
    getHqData: function (idKeys, data) {
      let _this = this;
      let obj = {
        type: 'cl',
        groupID: idKeys
        // field: 'Desc'
      };
      getFactorHq(obj)
        .then((res) => {
          if (res.err === 200) {
            const mergedArr = data.map((item1) => {
              const item2 = res.data.find((item) => item.ID == item1.f_id_arr.replaceAll(',', '_'));
              return {
                ...item1,
                RiZhangFu: item2.RiZhangFu,
                ID: item2.ID,
                XinHaoShuLiang: item2.XinHaoShuLiang
              };
            });

            _this.clList.push(...mergedArr);
            _this.loading = false;
          } else {
            _this.clList = data;
            _this.loading = false;
            _this.disabled = true;
            _this.loading_text = '已加载全部';
          }

          if (_this.clList.length) {
            _this.isShoWempty = false;
          } else {
            _this.isShoWempty = true;
          }
        })
        .catch(() => {
          _this.loading = false;
          _this.isShoWempty = true;
          _this.loading_text = '加载失败，点击重试';
        });
    },

    // 策略更多
    loadingMore: function () {
      this.page++;
      this.getHotClLeaderboardFun();
    },

    // 跳转策略详情
    goclDetail: function (item) {
      // 判断是否是 vip
      if(this.isVip == false && compareVersions(this.$route.query.version , 9.92)) {
        let appJson = {
          DialogType: "basic",
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorTYPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else if (this.isVip == false && compareVersions(this.$route.query.version , 9.71)) {
        // 如果不是VIP用户,弹出VIP提示
        let appJson = {
          channel: 'yinzi',
          dzhadid: '0703'
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorNoVipPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else {
        location.href = '/clDetail?DZHSPECIAL=4325641&type=hot&s_id=' + item.s_id;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.Yzcl {
  margin-top: 30px;
  .yzcl_header {
    position: sticky;
    background: #fff;
  }
  .title_t {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 9px;
    padding: 0 16px;
    .name {
      display: flex;
      align-items: center;
      ::v-deep {
        .van-icon-question-o {
          margin-left: 5px;
          margin-top: 2px;
        }
      }
    }
    p {
      color: #222;
      &:first-child {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
      }
    }
  }

  .card {
    ::v-deep {
      .van-tabs__nav--card {
        margin: 0 0 0 15px;
        border: none;
        .van-tab {
          border-radius: 6px;
          border: 1px solid #f5f6f9;
          margin-right: 8px;
          font-size: 13px;
          color: #999;
          height: 26px;
        }
        .van-tab--active {
          background: #eaf0fe;
          border: 1px solid #eaf0fe;
          color: #286df7;
          font-weight: 600;
        }
      }
    }
  }

  .hint {
    background: #f7f8fa;
    padding: 8px 16px;
    color: #999;
    font-size: 12px;
    margin-top: 5px;
  }

  .list_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    .left_name {
      color: #999;
      font-size: 12px;
      flex-shrink: 0;
      width: 85px;
    }
    .click {
      display: flex;
      align-items: center;
      width: 100%;

      li {
        display: flex;
        align-items: center;
        width: calc(100% - 85px);
        flex-shrink: 0;
        justify-content: flex-end;
        &:nth-child(1) {
          width: 99px;
          flex-shrink: 0;
        }
        &:nth-child(2) {
          width: 72px;
          flex-shrink: 0;
        }
        &:nth-child(3) {
          width: 88px;
          flex-shrink: 0;
        }

        .name {
          color: #999;
          font-size: 12px;
        }
        .arrow-up {
          border: 3px solid transparent;
          border-bottom-color: #999;
          display: block;
          margin-left: 2px;
        }

        .arrow-down {
          border: 3px solid transparent;
          border-top-color: #999;
          display: block;
          margin-left: 2px;
          margin-top: 2px;
        }

        .arrow-up-bg {
          border-bottom-color: #286df7;
        }

        .arrow-down-bg {
          border-top-color: #286df7;
        }
      }
    }
  }

  .list {
    padding: 0 16px;
    .list_li {
      padding: 12px 0;

      .list_li_top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .name {
          color: #555;
          font-size: 16px;
          font-weight: bold;
          flex-shrink: 0;
          width: 130px;
        }
        .t_right {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          p {
            text-align: right;
            color: #555;
            font-size: 14px;
            font-weight: 500;
            &:nth-child(1) {
              width: 25%;
            }
            &:nth-child(2) {
              width: 34%;
            }
            &:nth-child(3) {
              width: 41%;
            }
          }
          div {
            width: 41%;
            text-align: right;
          }
        }
      }
      .desc {
        color: #999;
        font-size: 12px;
      }
      .list_li_bottom {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-top: 6px;
        .btm_li {
          display: flex;
          align-items: center;
          border-radius: 4px;
          border: 1px solid #f5f6f9;
          width: 142px;
          flex-shrink: 0;
          margin-right: 8px;
          .btm_li_left {
            border-radius: 4px 0px 0px 4px;
            background: rgba(0, 0, 0, 0.02);
            color: #999;
            flex-shrink: 0;
            font-size: 11px;
            padding: 0 5px;
            border-radius: 3px 0 0 3px;
          }
          .btm_li_right {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #999;
            font-size: 11px;
            padding: 0 5px;
          }
        }
      }
    }

    .loadingMore {
      ::v-deep {
        .van-button {
          width: 100%;
          border-radius: 6px;
          background: rgba(40, 109, 247, 0.04);
          border: none;
          color: #286df7;
          height: 33px;
        }

        .van-button__text {
          font-size: 12px;
        }
      }
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  .yzcl_header {
    background: #1a1c26;
  }
  .title_t {
    p {
      &:first-child {
        color: #e4e9fe;
      }
      &:last-child {
        background: #1d202d;
        color: #e4e9fe;
      }
    }
  }
  .card {
    ::v-deep {
      .van-tab {
        border: 1px solid #202229 !important;
        .van-tab__text {
          color: #999;
        }
      }

      .van-tab--active {
        background: #1f2f4f !important;
        border: 1px solid #1f2f4f !important;
        .van-tab__text {
          color: #286df7;
        }
      }
    }
  }
  .hint {
    background: none;
    color: #aab9d1;
  }
  .list_header {
    .left_name {
      color: #6b7687;
    }
    .click {
      .name {
        color: #6b7687 !important;
      }

      .arrow-up {
        border-bottom-color: #6b7687;
      }

      .arrow-down {
        border-top-color: #6b7687;
      }

      .arrow-up-bg {
        border-bottom-color: #3b85fe;
      }
    }
  }

  .list {
    .list_li {
      .list_li_top {
        .name {
          color: #aab9d1;
        }
        .t_right {
          p,
          .day {
            color: #aab9d1;
          }
        }
      }
      .desc {
        color: #6b7687;
      }
      .list_li_bottom {
        .btm_li {
          border: 1px solid #484951;

          .btm_li_left {
            background: #202229;
            color: #6b7687;
          }
          .btm_li_right {
            p {
              color: #6b7687;
            }
          }
        }
      }
    }
    .loadingMore {
      ::v-deep {
        .van-button {
          background: #1e2940 !important;
          border: none !important;
          color: #286df7 !important;
        }
      }
    }
  }
}
</style>
